import { React, StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RecipeContextProvider } from "./components/store/recipe-context";
import { ImportRecipeContextProvider } from "./components/store/import-recipe-context";

import "./components/fonts/FontFace.css";
import "./components/fonts/MPLUSRounded1c-Black.ttf";
import "./components/fonts/MPLUSRounded1c-Bold.ttf";
import "./components/fonts/MPLUSRounded1c-ExtraBold.ttf";
import "./components/fonts/MPLUSRounded1c-Light.ttf";
import "./components/fonts/MPLUSRounded1c-Medium.ttf";
import "./components/fonts/MPLUSRounded1c-Regular.ttf";
import "./components/fonts/MPLUSRounded1c-Thin.ttf";
import { TabContextProvider } from "./components/store/tab-context";
import { UnitContextProvider } from "./components/store/unit-context";
import { ConvertContextProvider } from "./components/store/convert-context";
import { ParseContextProvider } from "./components/store/parse-context";

ReactDOM.createRoot(document.getElementById("root")).render(
  <StrictMode>
    <UnitContextProvider>
      <ConvertContextProvider>
        <ParseContextProvider>
          <RecipeContextProvider>
            <ImportRecipeContextProvider>
              <TabContextProvider>
                <App />
              </TabContextProvider>
            </ImportRecipeContextProvider>
          </RecipeContextProvider>
        </ParseContextProvider>
      </ConvertContextProvider>
    </UnitContextProvider>
  </StrictMode>
);
